import ReactDOM from 'react-dom/server';
import React from 'react';

import SchedulingConflict from './SchedulingConflict';

function staticErrorHTML(ErrorView) {
    return (error) => ReactDOM.renderToStaticMarkup(<ErrorView error={error} />);
}

/**
 * Contains a mapping of error codes to renderers to display the error
 * @type {{string}}
 */
const errors = {
    /**
     * Error renderer for scheduling conflict errors, where a staff member
     * attempts to edit an appointment or scheduling block in a way that
     * conflicts with another item on their calendar.
     */
    "scheduling.conflict": staticErrorHTML(SchedulingConflict),

    /**
     * Returns the renderer for error, based on the error ID, or undefined
     * if there's no error renderer.
     *
     * @param {object} error an object with an errorId property identifying
     *                       the error type.
     * @returns {function} a function that can render this error into
     *                     static HTML.
     */
    renderer(error) {
        return this[error && error.errorId];
    },

    /**
     * Presents a JSON error from an ExtJS ajax response if there's an
     * error-specific view.
     *
     * If there's no error-specific view, calls the [orElse] default
     * error handler.
     *
     * @param {object} response an ExtJS JSON response object, possibly undefined.
     * @param {function} errorMessagePresenter a function that presents the given
     *                   error message to the end-user.
     * @param {function} orElse a fallback error handler that should be called
     *                   if [error] isn't a recognized error.
     * @returns {undefined} no return value
     */
    showOperationSpecificErrorOrElse({response, errorMessagePresenter, orElse}) {
        if (!response || !response.result || !response.result.error) {
            return void orElse();
        }
        const renderer = this.renderer(response.result.error);
        if (!renderer) {
            return void orElse();
        }
        return void errorMessagePresenter(renderer(response.result.error));
    },
};

export default errors;
